var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-card', {
    staticClass: "table-filter-pill-panel",
    "class": {
      'table-filter-pill-panel--daterange': _vm.isDateRange,
      'table-filter-pill-panel--combobox': _vm.isComboboxText
    },
    attrs: {
      "flat": ""
    }
  }, [_vm.isNumberRange ? _c('div', {
    staticClass: "pa-3"
  }, [_c('div', {
    staticClass: "table-filter-pill-panel__header table-filter-pill-panel__header--inline text-body-2 font-weight-medium mb-2"
  }, [_vm._v(" " + _vm._s(_vm.filter.label) + " ")]), _c('v-row', {
    attrs: {
      "dense": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "type": "text",
      "inputmode": "decimal",
      "dense": "",
      "outlined": "",
      "hide-details": "",
      "autofocus": "",
      "label": _vm.$translate('numberRangeMin'),
      "suffix": _vm.filter.unit
    },
    model: {
      value: _vm.pickerMin,
      callback: function callback($$v) {
        _vm.pickerMin = $$v;
      },
      expression: "pickerMin"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "type": "text",
      "inputmode": "decimal",
      "dense": "",
      "outlined": "",
      "hide-details": "",
      "label": _vm.$translate('numberRangeMax'),
      "suffix": _vm.filter.unit
    },
    model: {
      value: _vm.pickerMax,
      callback: function callback($$v) {
        _vm.pickerMax = $$v;
      },
      expression: "pickerMax"
    }
  })], 1)], 1), _c('v-card-actions', {
    staticClass: "px-0 pb-0 pt-2"
  }, [_c('v-spacer'), _c('v-btn', {
    attrs: {
      "small": "",
      "text": ""
    },
    on: {
      "click": function click($event) {
        return _vm.$emit('close');
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$translate("dateRangeClose")) + " ")]), _c('v-btn', {
    attrs: {
      "color": "primary",
      "small": "",
      "text": "",
      "disabled": !_vm.hasNumberRangeInput
    },
    on: {
      "click": _vm.applyNumberRange
    }
  }, [_vm._v(" " + _vm._s(_vm.$translate("dateRangeApply")) + " ")])], 1)], 1) : _vm.isSlider ? _c('div', {
    staticClass: "pa-3 table-filter-pill-panel--slider"
  }, [_c('div', {
    staticClass: "table-filter-pill-panel__header table-filter-pill-panel__header--inline d-flex align-center justify-space-between text-body-2 font-weight-medium mb-2"
  }, [_c('span', [_vm._v(_vm._s(_vm.filter.label))]), _c('span', {
    staticClass: "table-filter-pill-panel__slider-value"
  }, [_vm._v(" " + _vm._s(_vm.sliderDisplayValue) + " ")])]), _c('v-slider', {
    attrs: {
      "min": _vm.sliderMin,
      "max": _vm.sliderMax,
      "step": _vm.sliderStep,
      "hide-details": "",
      "dense": "",
      "thumb-label": ""
    },
    model: {
      value: _vm.sliderValue,
      callback: function callback($$v) {
        _vm.sliderValue = $$v;
      },
      expression: "sliderValue"
    }
  }), _c('v-card-actions', {
    staticClass: "px-0 pb-0 pt-2"
  }, [_c('v-spacer'), _c('v-btn', {
    attrs: {
      "small": "",
      "text": ""
    },
    on: {
      "click": function click($event) {
        return _vm.$emit('close');
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$translate("dateRangeClose")) + " ")]), _c('v-btn', {
    attrs: {
      "color": "primary",
      "small": "",
      "text": ""
    },
    on: {
      "click": _vm.applySlider
    }
  }, [_vm._v(" " + _vm._s(_vm.$translate("dateRangeApply")) + " ")])], 1)], 1) : _vm.isDateRange ? [_c('div', {
    staticClass: "table-filter-pill-panel__header px-3 py-2 text-body-2 font-weight-medium"
  }, [_vm._v(" " + _vm._s(_vm.filter.label) + " ")]), _vm.showDateRangePresets ? _c('div', {
    staticClass: "table-filter-pill-panel__presets px-2 pt-2"
  }, _vm._l(_vm.datePresetChoices, function (code) {
    return _c('v-btn', {
      key: code,
      "class": ['text-none table-filter-pill-panel__preset', {
        'table-filter-pill-panel__preset--active': _vm.selectedPreset === code
      }],
      attrs: {
        "x-small": "",
        "text": ""
      },
      on: {
        "click": function click($event) {
          return _vm.selectPreset(code);
        }
      }
    }, [_vm._v(" " + _vm._s(_vm.datePresetLabel(code)) + " ")]);
  }), 1) : _vm._e(), _c('v-date-picker', {
    attrs: {
      "range": "",
      "color": "primary",
      "scrollable": "",
      "no-title": "",
      "first-day-of-week": 1
    },
    model: {
      value: _vm.pickerRange,
      callback: function callback($$v) {
        _vm.pickerRange = $$v;
      },
      expression: "pickerRange"
    }
  }), _c('v-divider'), _c('v-card-actions', {
    staticClass: "px-3 py-2"
  }, [_c('v-spacer'), _c('v-btn', {
    attrs: {
      "small": "",
      "text": ""
    },
    on: {
      "click": function click($event) {
        return _vm.$emit('close');
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$translate("dateRangeClose")) + " ")]), _c('v-btn', {
    attrs: {
      "color": "primary",
      "small": "",
      "text": "",
      "disabled": !_vm.isRangeComplete
    },
    on: {
      "click": _vm.applyDateRange
    }
  }, [_vm._v(" " + _vm._s(_vm.$translate("dateRangeApply")) + " ")])], 1)] : _vm.isDateTime ? _c('div', {
    staticClass: "pa-2"
  }, [_c('div', {
    staticClass: "table-filter-pill-panel__header table-filter-pill-panel__header--inline px-1 py-2 text-body-2 font-weight-medium"
  }, [_vm._v(" " + _vm._s(_vm.filter.label) + " ")]), _c('DateTime', {
    attrs: {
      "fixed": true,
      "clearable": _vm.filter.clearable != false,
      "dense": true,
      "disabled": _vm.filter.disabled,
      "label": _vm.filter.label,
      "min-date": null,
      "value": _vm.value,
      "hide-details": ""
    },
    on: {
      "input": _vm.onDateTimeInput
    }
  })], 1) : _vm.isComboboxText ? [_c('div', {
    staticClass: "px-3 pt-3"
  }, [_c('v-text-field', {
    attrs: {
      "value": _vm.textValue,
      "label": _vm.comboboxLabel,
      "type": _vm.filter.type === 'float' || _vm.filter.type === 'integer' ? 'number' : 'text',
      "dense": "",
      "hide-details": "",
      "outlined": "",
      "autofocus": "",
      "clearable": "",
      "loading": _vm.loading
    },
    on: {
      "input": _vm.onTextInput,
      "keydown": function keydown($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        $event.preventDefault();
        return _vm.applyTextInput.apply(null, arguments);
      }
    }
  })], 1), _vm.loading ? _c('v-progress-linear', {
    attrs: {
      "indeterminate": ""
    }
  }) : _vm.comboboxListChoices.length ? _c('div', {
    staticClass: "table-filter-pill-panel__list-wrap"
  }, [_c('v-list', {
    staticClass: "table-filter-pill-panel__list py-0",
    attrs: {
      "dense": ""
    }
  }, _vm._l(_vm.comboboxListChoices, function (choice, index) {
    return _c('v-list-item', {
      key: 'combobox-' + String(choice.value) + '-' + index,
      staticClass: "table-filter-pill-panel__item",
      on: {
        "click": function click($event) {
          return _vm.onComboboxChoiceClick(choice);
        }
      }
    }, [_c('v-list-item-content', [_vm.isCatalogChoiceDisplay(choice) ? _c('CatalogChoiceLabel', {
      attrs: {
        "seller-name": choice.sellerName,
        "catalog-name": choice.catalogName,
        "seller-connected": choice.sellerConnected
      }
    }) : _c('v-list-item-title', {
      staticClass: "table-filter-pill-panel__choice-title"
    }, [_c('MiddleEllipsisText', {
      attrs: {
        "text": choice.text
      }
    })], 1)], 1)], 1);
  }), 1)], 1) : _vm._e()] : _vm.isPlainTextInput ? _c('div', {
    staticClass: "pa-3"
  }, [_c('v-text-field', {
    attrs: {
      "value": _vm.textValue,
      "label": _vm.filter.label,
      "type": _vm.filter.type === 'float' || _vm.filter.type === 'integer' ? 'number' : 'text',
      "dense": "",
      "hide-details": "",
      "outlined": "",
      "autofocus": "",
      "clearable": ""
    },
    on: {
      "input": _vm.onTextInput,
      "keydown": function keydown($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        $event.preventDefault();
        return _vm.applyTextInput.apply(null, arguments);
      }
    }
  })], 1) : _vm.isPanelList ? [_vm.filter.multiple ? _c('div', {
    staticClass: "table-filter-pill-panel__header px-3 py-2 text-body-2 font-weight-medium"
  }, [_vm._v(" " + _vm._s(_vm.filter.label) + " ")]) : _vm._e(), _vm.showSearch ? _c('div', {
    staticClass: "px-2 pt-2 pb-1"
  }, [_c('v-text-field', {
    attrs: {
      "dense": "",
      "hide-details": "",
      "solo": "",
      "flat": "",
      "background-color": "transparent",
      "prepend-inner-icon": "mdi-magnify",
      "placeholder": _vm.searchPlaceholder,
      "autofocus": "",
      "clearable": ""
    },
    on: {
      "input": _vm.onSearchInput
    },
    model: {
      value: _vm.searchQuery,
      callback: function callback($$v) {
        _vm.searchQuery = $$v;
      },
      expression: "searchQuery"
    }
  })], 1) : _vm._e(), _vm.loading ? _c('v-progress-linear', {
    attrs: {
      "indeterminate": ""
    }
  }) : _c('div', {
    ref: "listWrap",
    staticClass: "table-filter-pill-panel__list-wrap",
    on: {
      "&scroll": function scroll($event) {
        return _vm.onListScroll.apply(null, arguments);
      }
    }
  }, [_c('v-list', {
    staticClass: "table-filter-pill-panel__list py-0",
    attrs: {
      "dense": ""
    }
  }, [!_vm.displayChoices.length ? [_c('v-list-item', {
    attrs: {
      "disabled": ""
    }
  }, [_c('v-list-item-title', {
    staticClass: "text-caption grey--text"
  }, [_vm._v(" " + _vm._s(_vm.$translate("noResults")) + " ")])], 1)] : _vm._e(), _vm._l(_vm.displayChoices, function (choice, index) {
    return [choice.header ? _c('v-subheader', {
      key: 'header-' + index,
      staticClass: "px-3"
    }, [_vm._v(" " + _vm._s(choice.header) + " ")]) : _c('v-list-item', {
      key: 'choice-' + String(choice.value) + '-' + index,
      staticClass: "table-filter-pill-panel__item",
      on: {
        "click": function click($event) {
          return _vm.onChoiceClick(choice);
        }
      }
    }, [_vm.filter.multiple ? _c('v-list-item-action', {
      staticClass: "mr-2 my-0 align-self-center"
    }, [_c('v-checkbox', {
      staticClass: "mt-0 pt-0",
      attrs: {
        "input-value": _vm.isSelected(choice.value),
        "hide-details": "",
        "dense": ""
      },
      on: {
        "click": function click($event) {
          $event.stopPropagation();
          return _vm.toggleChoice(choice);
        }
      }
    })], 1) : _vm._e(), _c('v-list-item-content', [_vm.isCatalogChoiceDisplay(choice) ? _c('CatalogChoiceLabel', {
      attrs: {
        "seller-name": choice.sellerName,
        "catalog-name": choice.catalogName,
        "seller-connected": choice.sellerConnected
      }
    }) : _c('v-list-item-title', {
      staticClass: "table-filter-pill-panel__choice-title"
    }, [_c('MiddleEllipsisText', {
      attrs: {
        "text": choice.text
      }
    })], 1)], 1), !_vm.filter.multiple && _vm.isSelected(choice.value) ? _c('v-list-item-action', {
      staticClass: "my-0"
    }, [_c('v-icon', {
      attrs: {
        "small": "",
        "color": "primary"
      }
    }, [_vm._v("mdi-check")])], 1) : _vm._e()], 1)];
  }), _vm.loadingMore ? _c('v-list-item', {
    attrs: {
      "disabled": ""
    }
  }, [_c('v-list-item-content', [_c('v-progress-linear', {
    attrs: {
      "indeterminate": ""
    }
  })], 1)], 1) : _vm._e()], 2)], 1), _vm.filter.multiple && _vm.visibleSelectableChoices.length ? [_c('v-divider'), _c('v-list', {
    staticClass: "py-0",
    attrs: {
      "dense": ""
    }
  }, [_c('v-list-item', {
    staticClass: "table-filter-pill-panel__item",
    on: {
      "click": _vm.toggleSelectAll
    }
  }, [_c('v-list-item-action', {
    staticClass: "mr-2 my-0 align-self-center"
  }, [_c('v-checkbox', {
    staticClass: "mt-0 pt-0",
    attrs: {
      "input-value": _vm.allSelected,
      "indeterminate": _vm.someSelected && !_vm.allSelected,
      "hide-details": "",
      "dense": ""
    }
  })], 1), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v(_vm._s(_vm.selectAllLabel))])], 1)], 1)], 1)] : _vm._e()] : _vm._e()], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }